import React from 'react';
import PromotionsForm from './PromotionsForm';

const EditPromotion = ({ show, onHide, rowData }) => (
  <PromotionsForm show={show} onHide={onHide} mode="edit" initialRow={rowData || null} />
);

export default EditPromotion;
